/* Behaviour for the shared sort control (snippets/ca-sort-control.liquid, assets/ca-sort.css).

   The markup is a <details>, so it opens, closes and announces its state with no JS at all. This file
   only adds the two things a <details> does not do by itself: close when the click lands outside it,
   and close on Escape.

   Two modes:

   - link mode. Each option is an <a href="?sort_by=...">. Nothing to intercept - the browser navigates.
   - select mode. Each option is a <button>, and the control carries data-ca-sort-target pointing at a
     visually hidden <select> the host page's own script already listens to. Clicking an option writes
     the value into that select and fires a bubbling 'change', so the host script keeps working
     untouched and knows nothing about this control.

   One delegated listener pair on the document covers every control on the page, including ones the
   theme editor adds later. */
(function () {
  'use strict';

  function close(details, focusButton) {
    if (!details || !details.open) return;
    details.open = false;
    if (focusButton) {
      var summary = details.querySelector('summary');
      if (summary) summary.focus();
    }
  }

  function closeOthers(except) {
    var open = document.querySelectorAll('.ca-sort[open]');
    for (var i = 0; i < open.length; i++) {
      if (open[i] !== except) close(open[i], false);
    }
  }

  function choose(option) {
    var details = option.closest('.ca-sort');
    if (!details) return;

    var targetId = details.getAttribute('data-ca-sort-target');
    var select = targetId ? document.getElementById(targetId) : null;
    if (!select) return;

    var value = option.getAttribute('data-value');
    if (value === null || select.value === value) {
      close(details, true);
      return;
    }

    select.value = value;
    // The host page's script listens for 'change' on the select it rendered itself; it never sees
    // this control.
    select.dispatchEvent(new Event('change', { bubbles: true }));

    // Reflect the new order on the button and the tick, the way a reload would have.
    var value_el = details.querySelector('[data-ca-sort-value]');
    if (value_el) value_el.textContent = (option.textContent || '').trim();

    var options = details.querySelectorAll('.ca-sort__option');
    for (var i = 0; i < options.length; i++) {
      if (options[i] === option) {
        options[i].setAttribute('aria-current', 'true');
      } else {
        options[i].removeAttribute('aria-current');
      }
    }

    close(details, true);
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var option = target.closest('.ca-sort__option');
    if (option && option.tagName === 'BUTTON') {
      choose(option);
      return;
    }

    // A click anywhere else closes any panel it did not land inside - including the summary of
    // another control, which is why this runs after the option branch above.
    closeOthers(target.closest('.ca-sort'));
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var open = document.querySelector('.ca-sort[open]');
    if (!open) return;
    // Only when this control is the thing on screen; otherwise let Escape reach whatever else is open.
    event.stopPropagation();
    close(open, true);
  });
})();
